import { motion } from 'framer-motion';

const Card = ({ icon: Icon, title, description, accentColor = 'lime' }) => {
  return (
    <motion.div
      className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-300"
      whileHover={{ y: -5 }}
    >
      {Icon && (
        <div className={`text-${accentColor} mb-4`}>
          <Icon className="w-12 h-12" />
        </div>
      )}
      <h3 className="text-xl font-display font-bold mb-3 text-navy">
        {title}
      </h3>
      {description && (
        <p className="text-gray-600 leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
};

export default Card;
